import { apiRequest, apiLambdaRequest } from '../apiRequest'

const getPrescriberCode = () => apiRequest('/v1/accounts/pro/prescribercode', {}).get()

const createPatientAccount = (data) =>
  apiRequest('/v1/accounts/patient/create', { result: {} }).post(data)

const createDoctorAccount = (newAccountDoctorData) =>
  apiRequest('/v1/accounts/doctor/create', {}).post(newAccountDoctorData)

const logoutUser = () => apiLambdaRequest('/logout', null).post()

export const accountsApi = {
  logoutUser,
  getPrescriberCode,
  createPatientAccount,
  createDoctorAccount,
}
